import type { ReactNode } from 'react'
import clsx from 'clsx'

/** 页面内容区 max-width 语义 */
export type PageContainerSize = 'sm' | 'md' | 'lg' | 'xl'

const SIZE_CLASS: Record<PageContainerSize, string> = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
}

type Props = {
  size?: PageContainerSize
  className?: string
  children: ReactNode
}

/** 业务页统一外边距与最大宽度 — 移动端 px-4，桌面端渐进放大 */
export function PageContainer({ size = 'lg', className, children }: Props) {
  return (
    <div
      className={clsx(
        'mx-auto w-full',
        SIZE_CLASS[size],
        'px-4 py-6 sm:px-6 sm:py-8 lg:px-8',
        className,
      )}
    >
      {children}
    </div>
  )
}
